import { __assign } from "tslib";
import React, { useContext } from 'react';
import { Text, BulletList } from '@keen.io/ui-core';
import TooltipItem from '../tooltip-item';
import { Total, TextContainer, LabelContainer, Container, BulletListContainer, } from './tooltip-content.styles';
import { ChartContext } from '../../contexts';
var TooltipContent = function (_a) {
    var items = _a.items, label = _a.label, totalValue = _a.totalValue, percentValue = _a.percentValue, _b = _a.maxWidth, maxWidth = _b === void 0 ? 200 : _b;
    var _c = useContext(ChartContext), theme = _c.theme, tooltip = _c.theme.tooltip;
    return (React.createElement(Container, { maxWidth: maxWidth },
        label && (React.createElement(LabelContainer, null,
            React.createElement(Text, __assign({ truncate: true }, tooltip.labels.typography), label.toString()))),
        React.createElement(BulletListContainer, null,
            React.createElement(BulletList, { items: items, renderItem: function (_idx, item) { return (React.createElement(TooltipItem, { data: item.data, theme: theme })); } })),
        totalValue !== null && (React.createElement(Total, null,
            React.createElement(Text, __assign({}, tooltip.labels.typography), "Total:"),
            percentValue ? (React.createElement(TextContainer, null,
                React.createElement(Text, __assign({}, tooltip.values.typography), percentValue.toFixed(1) + "%",
                    "\u00A0"),
                React.createElement(Text, __assign({}, tooltip.labels.typography), "(" + totalValue + ")"))) : (React.createElement(Text, __assign({}, tooltip.values.typography), totalValue))))));
};
export default TooltipContent;
